import { useEffect, useState } from "react";
import { ClipboardCheck, Check } from "lucide-react";

const ITEMS = [
  { id: "device", text: "Be next to the device that's acting up, powered on" },
  { id: "camera", text: "Have a phone or tablet with a camera ready to show me the gear (for video calls)" },
  { id: "remotes", text: "Gather remotes and any cables that came with the equipment" },
  { id: "passwords", text: "Know your Wi-Fi name & password and any app logins (camera app, streaming, router)" },
  { id: "model", text: "Note the brand and model number (usually on a sticker on the back or bottom)" },
  { id: "what", text: "Be ready to describe what changed and what you've already tried" },
  { id: "charged", text: "Charge your phone and stay near good Wi-Fi or cell signal" },
];

export function PrepChecklist({ compact = false }) {
  const [done, setDone] = useState(() => JSON.parse(localStorage.getItem("dg_prep") || "{}"));
  useEffect(() => { localStorage.setItem("dg_prep", JSON.stringify(done)); }, [done]);
  const count = ITEMS.filter((i) => done[i.id]).length;

  return (
    <section className={`dg-card rounded-2xl ${compact ? "p-5" : "p-6 sm:p-8"}`} data-testid="prep-checklist">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <span className="dg-eyebrow flex items-center gap-2"><ClipboardCheck className="w-3 h-3" /> Before your call</span>
          <h2 className="mt-2 text-lg md:text-xl font-bold font-display">Have these ready and we'll fix it faster.</h2>
        </div>
        <span className="dg-chip" data-testid="prep-progress">{count}/{ITEMS.length} ready</span>
      </div>
      <ul className="mt-5 grid gap-2 sm:grid-cols-2">
        {ITEMS.map((i) => (
          <li key={i.id}>
            <button type="button" onClick={() => setDone((d) => ({ ...d, [i.id]: !d[i.id] }))} data-testid={`prep-item-${i.id}`}
              className={`w-full text-left flex items-start gap-3 rounded-xl border px-3 py-2.5 text-sm transition-colors ${
                done[i.id] ? "border-cyan-500/50 bg-cyan-500/10 text-slate-300" : "border-slate-800 bg-slate-900/40 text-slate-200 hover:border-cyan-400/60"}`}>
              <span className={`mt-0.5 w-4 h-4 rounded border shrink-0 grid place-items-center ${done[i.id] ? "bg-cyan-500 border-cyan-500" : "border-slate-600"}`}>
                {done[i.id] && <Check className="w-3 h-3 text-slate-900" />}
              </span>
              <span className={done[i.id] ? "line-through decoration-slate-500" : ""}>{i.text}</span>
            </button>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-xs text-slate-500">Video call? David will send the link or code before your session. Phone call? He'll call the number you booked with.</p>
    </section>
  );
}
